var _rect, _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFreeQa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42_17173",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 15,
    width: 31,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.2022,
    height: 33.2225,
    transform: "matrix(-1 0 0 1 33.3481 15.1007)",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42_17173)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1618,
    height: 24.1618,
    rx: 9.06067,
    transform: "matrix(-1 0 0 1 29.5728 39.2627)",
    fill: "url(#paint0_linear_42_17173)",
    stroke: "url(#paint1_linear_42_17173)",
    strokeWidth: 2.1573,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.8456,
    cy: 5.8456,
    r: 5.8456,
    transform: "matrix(-1 0 0 1 23.9099 22.3993)",
    fill: "url(#paint2_linear_42_17173)",
    stroke: "url(#paint3_linear_42_17173)",
    strokeWidth: 2.1573,
    strokeLinecap: "square"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9438 31.0412V11.9551C28.9438 10.7869 29.4079 9.66662 30.2339 8.84061C31.0599 8.01461 32.1802 7.55057 33.3483 7.55057H48.03C49.1981 7.55057 50.3184 8.01461 51.1444 8.84061C51.9704 9.66662 52.4345 10.7869 52.4345 11.9551V20.764C52.4345 21.9322 51.9704 23.0525 51.1444 23.8785C50.3184 24.7045 49.1981 25.1685 48.03 25.1685H34.8165L28.9438 31.0412Z",
    fill: "url(#paint4_linear_42_17173)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6895 14.951C41.4679 14.951 42.0989 15.582 42.0989 16.3604V16.3751C42.0989 17.1535 41.4679 17.7845 40.6895 17.7845C39.9111 17.7845 39.28 17.1535 39.28 16.3751V16.3604C39.28 15.582 39.9111 14.951 40.6895 14.951Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8169 14.951C35.5953 14.951 36.2263 15.582 36.2263 16.3604V16.3751C36.2263 17.1535 35.5953 17.7845 34.8169 17.7845C34.0385 17.7845 33.4075 17.1535 33.4075 16.3751V16.3604C33.4075 15.582 34.0385 14.951 34.8169 14.951Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5618 14.951C47.3402 14.951 47.9712 15.582 47.9712 16.3604V16.3751C47.9712 17.1535 47.3402 17.7845 46.5618 17.7845C45.7834 17.7845 45.1523 17.1535 45.1523 16.3751V16.3604C45.1523 15.582 45.7834 14.951 46.5618 14.951Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_17173",
    x1: 2.7182,
    y1: 4.53034,
    x2: 21.1545,
    y2: 6.16535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3C2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_42_17173",
    x1: 2.7182,
    y1: 4.53034,
    x2: 21.1545,
    y2: 6.16535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3C2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_42_17173",
    x1: 1.31526,
    y1: 2.1921,
    x2: 10.236,
    y2: 2.98323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3C2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_42_17173",
    x1: 1.31526,
    y1: 2.1921,
    x2: 10.236,
    y2: 2.98323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3C2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_42_17173",
    x1: 31.5865,
    y1: 11.9551,
    x2: 49.5107,
    y2: 13.5447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3C2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFreeQa);
export default __webpack_public_path__ + "static/media/icon_free_qa.1f26fbf363ebc452a877f6905694957f.svg";
export { ForwardRef as ReactComponent };